(function () {
  var CART_ICON = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M6 16a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm8 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM2 2h2l2 9h8l2-7H6"/></svg>';
  var CHECK_ICON = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><polyline points="3,10 8,15 17,5"/></svg>';
  var SPINNER = '<span class="cro-atc-spinner" aria-hidden="true"></span>';

  function setAdding(btn) {
    btn.disabled = true;
    btn.classList.add('cro-card-atc__btn--adding');
    btn.classList.remove('cro-card-atc__btn--added');
    btn.innerHTML = SPINNER + 'Adding\u2026';
  }

  function setAdded(btn) {
    btn.classList.remove('cro-card-atc__btn--adding');
    btn.classList.add('cro-card-atc__btn--added');
    btn.innerHTML = CHECK_ICON + 'Added!';
  }

  function setIdle(btn) {
    btn.disabled = false;
    btn.classList.remove('cro-card-atc__btn--adding', 'cro-card-atc__btn--added');
    btn.innerHTML = CART_ICON + 'Add to Cart';
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form.cro-card-atc__form');
    if (!form) return;

    e.preventDefault();
    e.stopPropagation();

    var submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) setAdding(submitBtn);

    var cart =
      document.querySelector('cart-drawer') ||
      document.querySelector('cart-notification');

    var formData = new FormData(form);
    if (cart) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function (s) { return s.section; }).join(',')
      );
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);
    }

    var cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

    fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/javascript'
      },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.errors) {
          console.error('[CRO ATC] Cart error:', response.errors);
          if (submitBtn) setIdle(submitBtn);
          return;
        }
        if (cart) cart.renderContents(response);
        if (typeof updateCartCounters === 'function') updateCartCounters();
        if (submitBtn) {
          setAdded(submitBtn);
          setTimeout(function () { setIdle(submitBtn); }, 1800);
        }
      })
      .catch(function (err) {
        console.error('[CRO ATC]', err);
        if (submitBtn) setIdle(submitBtn);
      });
  });
})();
